export default
`
2019: PhD in Medical Sciences, University of Exeter, UK. \r\n
2015: Masters by Research, Cellular and Molecular Physiology, University of Liverpool, UK.\r\n
2014: Bachelor of Science, Nutrition and Dietetics, University of Chester, UK.  \r\n

`


// WEBPACK FOOTER //
// ./src/content/education.js